import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() navShown:boolean;
  processingLogin: boolean;
  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.processingLogin=true;
    setTimeout(() => {
      this.route.queryParams.subscribe((params: any) => {
        if (Object.keys(params).length) { //params like accessToken and expiresIn
          this.processingLogin=true;
        }
        else
          this.processingLogin=false;
      })
    }, 10);//A dealy of 10ms is provided to counter the unexpected behaviour of ActivatedRoute subscription with the hidden attribute in html page
  }

}
